import React from 'react';
import { Box, ScrollArea } from '@mantine/core';
import { FilterCategory, ActiveFilter } from '../../types';
import { ChildFilterItem } from './ChildFiltersDropdown';
import FiltersList from './FiltersList';

/** Re-export for consumers of LeftPanel */
export type { ChildFilterItem };

export interface LeftPanelProps {
  ideaCategories: FilterCategory[];
  evidenceCategories: FilterCategory[];
  getCategoryTooltip: (categoryId: string, disabled: boolean) => string;
  getCategoryIcon: (categoryId: string) => React.ReactNode;
  handleCategorySelect: (categoryId: string, categoryType: 'idea' | 'evidence') => void;
  selectedCategory: string;
  childFilters: ChildFilterItem[];
  categoryIdsWithChildren: Set<string>;
  searchInput: React.ReactNode;
  handleChildFilterSelect: (childFilterId: string) => void;
  middlePanelSearch: string;
  isFromIdeas?: boolean;
  localActiveFilters?: ActiveFilter[];
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  ideaCategories,
  evidenceCategories,
  getCategoryTooltip,
  getCategoryIcon,
  handleCategorySelect,
  selectedCategory,
  childFilters,
  categoryIdsWithChildren,
  searchInput,
  handleChildFilterSelect,
  middlePanelSearch,
  isFromIdeas = false,
  localActiveFilters = [],
}) => {
  return (
    <Box className="filter-modal-left-panel" 
      sx={{ display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0 }}>

      <ScrollArea sx={{ flex: 1, minHeight: 0 }}>
        <Box
          pt='md'
          pl="md"
          pb='lg'
          pr="md">
          {isFromIdeas && (
            <FiltersList
              title="Idea filters"
              categories={ideaCategories}
              handleCategorySelect={handleCategorySelect}
              selectedCategory={selectedCategory}
              childFilters={childFilters}
              categoryIdsWithChildren={categoryIdsWithChildren}
              searchInput={searchInput}
              handleChildFilterSelect={handleChildFilterSelect}
              middlePanelSearch={middlePanelSearch}
              localActiveFilters={localActiveFilters}
            />
          )}

          <FiltersList
            title="Evidence filters"
            categories={evidenceCategories}
            handleCategorySelect={handleCategorySelect}
            selectedCategory={selectedCategory}
            childFilters={childFilters}
            categoryIdsWithChildren={categoryIdsWithChildren}
            searchInput={searchInput}
            handleChildFilterSelect={handleChildFilterSelect}
            middlePanelSearch={middlePanelSearch}
            topPadding={isFromIdeas ? 20 : 0}
            localActiveFilters={localActiveFilters}
          />
        </Box>
      </ScrollArea>
    </Box>
  );
};

export default LeftPanel;
